export default {
  select_size: 'Selecionar tamanho',
  required: 'Obrigatório',
  required_missing: 'Obrigatório — por favor faça uma seleção',
  optional: 'Opcional',
  select_up_to: 'Selecionar até {{maxCount}}',
};
